import React from 'react'
import Box from 'core-system/Box/Box'
import Text from 'core-system/Text'
import styled from 'styled-components'

const Container = styled(Box)<{ status: boolean }>`
  margin-bottom: 3rem;
  padding: 1.25rem 2rem;
  border-radius: 0rem !important;
`

const IncompleteOnboardingBanner = (props) => {
  return (
    <Container backgroundImageType='gradient' {...props}>
      <Text variant='action4'>
        Complete the onboarding steps to gain full access to the platform
      </Text>
    </Container>
  )
}

export default IncompleteOnboardingBanner
